<template>
  <a :href="'tel:' + value.Phone" style="font-weight: bolder; font-size: 14px">
    {{ value.Phone }}
  </a>
</template>
<script>
  export default {
    props: ['value', 'id', 'config'],
    data() {
      return {
        showInput: false,
      };
    },
  };
</script>
